// hooks/usePreference.js
import { usePreferencesReady } from '../contexts/PreferencesContext';

// Custom hook for working with a specific preference
export const usePreference = (preferenceKey, defaultValue = null) => {
  const { preferences, updatePreferences, ...rest } = usePreferencesReady();
  
  // Get the current value of the specific preference
  const value = preferences[preferenceKey] ?? defaultValue;
  
  // Function to update just this preference
  const setValue = async (newValue) => {
    try {
      await updatePreferences({ [preferenceKey]: newValue });
      return newValue;
    } catch (error) {
      console.error(`Failed to update preference ${preferenceKey}:`, error);
      throw error;
    }
  };
  
  return [value, setValue, rest];
};

// Specific hooks for common preferences
export const useCalendarToggles = () => {
  const { preferences, updateCalendarToggles, toggleCalendarItem } = usePreferencesReady();
  
  return {
    toggles: preferences.calendarToggles,
    updateToggles: updateCalendarToggles,
    toggleItem: toggleCalendarItem
  };
};

export const useBudgetViewType = () => {
  const { preferences, updateBudgetViewType } = usePreferencesReady();
  
  return {
    viewType: preferences.budgetViewType,
    setViewType: updateBudgetViewType
  };
};

export const useActionsViewType = () => {
  const { preferences, updateActionsViewType } = usePreferencesReady();
  
  return {
    viewType: preferences.actionsViewType,
    setViewType: updateActionsViewType
  };
};

// Hook for theme preference
export const useThemePreference = () => {
  const [theme, setTheme] = usePreference('theme', 'auto');
  
  return {
    theme,
    setTheme
  };
};

export default usePreference;
